import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import { LinkedJournalEntryCard } from "components/JournalEntry/LinkedJournalEntryCard";

type LinkedJournalEntryProps = {
  ledgerEntryIds: string[];
  entityId: string;
};

export const LinkedJournalEntry = ({
  ledgerEntryIds,
  entityId,
}: LinkedJournalEntryProps) => {
  if (ledgerEntryIds.length === 0) {
    return null;
  }

  return (
    <Accordion.Root
      type="single"
      collapsible
      defaultValue="LINKED_JOURNAL_ENTRY"
    >
      <Accordion.Item value="LINKED_JOURNAL_ENTRY">
        <Accordion.Trigger>Linked Journal Entry</Accordion.Trigger>
        <Accordion.Content className="t-flex t-flex-col t-gap-3">
          {ledgerEntryIds.map((ledgerEntryId) => (
            <LinkedJournalEntryCard
              key={ledgerEntryId}
              ledgerEntryId={ledgerEntryId}
              entityId={entityId}
            />
          ))}
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
